<template>
  <!-- 返回旧版 -->
  <div class="return-old-version" v-if="show">
    <div v-show="status" @click="jump" class="to-old">
      <img @click.stop="change(0)" class="close-i" src="/static/images/close-i3.png">
    </div>
    <div v-show="!status" class="up-arrow">
      <img @click.stop="change(1)" class="up-to" src="/static/images/up-to.png">
    </div>
  </div>
</template>
<script>
  export default {
    name: 'return-old-version',
    data () {
      return {
        show: false,
        status: true
      }
    },
    mounted () {
      if (window.store.get('show_goto_old') == '0') {
        this.status = false
      } else {
        this.status = true
      }
    },
    methods: {
      jump () {
        window.location.href = 'http://m.mcake.com'
      },
      change (status) {
        window.store.set('show_goto_old', status)
        this.status = status == 1 ? true : false
      }
    }
  }
</script>
<style scoped>

  .to-old {
    width: 100%;
    height: 1.5rem;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 1.3rem;
    background: url(/static/images/back-to.png) center center no-repeat;
    background-size: cover;
    z-index: 6;
  }

  .up-arrow {
    width: 100%;
    position: fixed;
    bottom: 1.2rem;
    z-index: 6;
    left: 0;
    right: 0;
    text-align: center;
  }

  .up-to {
    width: 100%;
    height: 0.5rem;
  }

  .close-i {
    position: absolute;
    left: 48%;
    top: -0.2rem;
    width: 0.5rem;
    height: 0.5rem;
    z-index: 6;
  }

</style>



// WEBPACK FOOTER //
// src/components/home/return-old-version.vue